import {Theme} from '@innowise-group/ui-kit';

export interface ColorKeys {
  colorKeys: string | string[];
}

export function getColorFromProps(props: ColorKeys & {theme: Theme}) {
  const {colorKeys, theme} = props;

  let distance = 0;

  return typeof colorKeys == 'string' && colorKeys !== 'notDefined'
    ? theme.palette.specials.workingDays[colorKeys]
    : `repeating-linear-gradient(45deg, ${(colorKeys === 'notDefined' || !colorKeys
        ? ['outOfOffice', 'noInfo']
        : colorKeys
      )
        .map((key) => `${theme.palette.specials.workingDays[key]} ${distance}px ${(distance += 5.4)}px`)
        .join(', ')})`;
}
